export default {
  collegeNews: '/course/manage/homepage/org/dynamic/query', //学院动态
  salesData: '/order/identify/adminOrder/saleStatistic',
  salesCountRank: '/course/admin/static/course/sale/rank',
  salesDynamic: '/course/identify/dynamic/sale/list',
}
